import { Loader, X } from 'lucide-react';
import { cn } from '../../utils/cn';
import type { EventTag } from '../../types/eventTeam';

interface EventTagChipProps {
  tag: EventTag;
  onRemove?: () => void;
  removing?: boolean;
  onClick?: () => void;
  active?: boolean;
  className?: string;
}

/** Hex-colored tag pill (shared across lists, detail headers and the dashboard filter row). */
export const EventTagChip = ({ tag, onRemove, removing, onClick, active, className }: EventTagChipProps) => {
  return (
    <span
      className={cn(
        'badge group/tag',
        onClick && 'cursor-pointer hover:brightness-125',
        active && 'ring-1 ring-current',
        className,
      )}
      style={{
        backgroundColor: `${tag.color}20`,
        borderColor: `${tag.color}40`,
        color: tag.color,
      }}
      onClick={onClick}
      title={tag.description || tag.name}
    >
      <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: tag.color }} />
      {tag.name}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          disabled={removing}
          className="-mr-0.5 opacity-60 hover:opacity-100 transition-opacity touch-manipulation p-0.5 rounded"
          title={`Remove tag ${tag.name}`}
          aria-label={`Remove tag ${tag.name}`}
        >
          {removing ? <Loader className="w-3 h-3 animate-spin" /> : <X className="w-3 h-3" />}
        </button>
      )}
    </span>
  );
};
